<template>
  <div>
    <h2>Munkafüzet</h2>
    <a href="/hh2026-munkafuzet.pdf" download><img class="download-icon" src="../assets/pdf-icon-peach.png"></a>
    <p>
      Itt vannak alább a segítő kérdések, letölhető, kinyomtatható formában is, amiket vagy használtok vagy nem..., előszőr
      magatokban gondolkozzatok el, akár le is írhatjátok, majd osszátok meg egymással! Legyetek bátrak! Isten látja, hogy ez jó!
    </p>

    <div class="list-wrapper">
      <ol>
        <li>Milyennek éled meg mostanában a kapcsolatunkat?</li>
        <li>Mik azok a pillanatok, események, amik fontosak neked, amiből megtapasztalod, hogy nagyon szeretlek?</li>
        <li>
          Érte-e mostanában kísértés a kapcsolatunkat? Harmadik személy, pornográfia, fásultság, beletörődés? 
          Hogyan tudjuk ezeket a jövőben tudatosan elkerülni?
        </li>
        <li>Mi az amire régóta vágysz, de nem kapod meg tőlem vagy csak ritkán?</li>
        <li>
          Mire fordítsunk több időt, hogy a házasságunk élő, mindkettőnknek boldogító legyen? Ha találtok ilyet, 
          tegyetek teljesíthető, konkrét elhatározást!
        </li>
      </ol>
    </div>

    <p>
      Ha még van erőtök és kedvetek, vegyétek le a jegygyűrűket, csókoljátok meg és húzzátok újra egymás ujjára, 
      az eskü szövegével:
    </p>
    <p class="citation">
      <i>
        „Kedvesem, ... viseld ezt a gyűrűt<br>
        szeretetem és hűségem jeléül<br>
        az Atya, a Fiú és a Szentlélek nevében”.
      </i>
    </p>  
    <p>
      Kérjük, készítsetek fotót a jegygyűrűs kezetekről, valamilyen módon legyen rajta a képen, hány éve vagytok házasok!
      A vacsorán majd jó kis játék lehet, vajon kiknek a kezét látjuk! Várjuk a képeket a 
      <a href="mailto:marosvet75 [kukac] gmail.com">marosvet75 [kukac] gmail.com</a> címre!
    </p>
  </div>
</template>
<script>
  //import EmbeddedMapComponent from './subcomponents/EmbeddedMapComponent.vue'

  export default {
    name: 'trials',
    components: {
      //'embedded-map': EmbeddedMapComponent
    },
    data: function() {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .download-icon {
    width: 44px;
    float: left;
    margin-top: 26px;
    margin-right: 8px;
    padding-right: 4px;
  }

  .worksheet {
    margin-top: 20px;
    width: 100%;
  }

  .sign {
    float: left;
    width: 168px;
    margin-top: 24px;
    margin-right: 8px;
    padding-right: 4px;
  }

  .citation {
    color: var(--highlight);
    padding-left: 20px;
    font-size: 1.6rem;
    font-family: var(--font-citation);
  }

  @media (max-width: 920px) {
    .sign {
      width: 150px;
    }
  }

  @media (min-width: 920px) {
    .download-icon {
      margin-bottom: 26px;
    }
  }
</style>